import useCategoryApi from "views/Catalog/Categories/hooks/useCategoryApi";
import useNotification from "utils/hooks/useNotification";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { FaUndoAlt } from "react-icons/fa";
import TooltipButton from "views/Documents/components/TooltipButton";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function ReactivateButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { reactivateCompanyPaymentDeadline } = useCategoryApi();
  const { notificationError } = useNotification();

  const confirmReactivate = (id: ID) => {
    Modal.confirm({
      title: t("Reactivate payment date limit"),
      content: t("Are you sure you want to reactivate this deadline ?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    const response = await reactivateCompanyPaymentDeadline({
      variables: {
        id,
      },
    });

    const errors = response?.data?.reactivateCompanyPaymentDeadline.errors;
    notificationError(errors);
    refetch!();
  };

  return (
    <TooltipButton
      title={t("Reactivate")}
      placement="top"
      handleOnClick={() => confirmReactivate(id)}
      icon={<FaUndoAlt />}
    />
  );
}
